//store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { userExperienceSlice } from "../components/user-experiences/slices";
import {
  adminSlice,
  authenticationSlice,
  businessAnalyticsSlice,
  businessSlice,
  errorSlice,
  eventSeriesSlice,
  experienceSlice,
  flagReportSlice,
  productSlice,
  searchAdminSlice,
  searchBusinessSlice,
  searchSlice,
  stateSlice,
  userSlice,
} from "./slices";

const rootReducer = combineReducers({
  auth: authenticationSlice.reducer,
  business: businessSlice.reducer,
  product: productSlice.reducer,
  search: searchSlice.reducer,
  error: errorSlice.reducer,
  businessAnalytics: businessAnalyticsSlice.reducer,
  user: userSlice.reducer,
  admin: adminSlice.reducer,
  searchAdmin: searchAdminSlice.reducer,
  state: stateSlice.reducer,
  searchBusiness: searchBusinessSlice.reducer,
  eventSeries: eventSeriesSlice.reducer,
  experience: experienceSlice.reducer,
  flagReport: flagReportSlice.reducer,
  userExperience: userExperienceSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
